import {
  jb_e_service_overlay_css_default
} from "./chunk.UZFU4TV7.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.JXPX63WS.js";
import {
  JBCookie,
  getEventElement
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-e-service-overlay/jb-e-service-overlay.ts
var JbEServiceOverlay = class extends Initiable(Animatable(r)) {
  firstUpdated() {
    this._cookieCountry = JBCookie.getI18nCookieData().country;
    this._eServiceLocations = this.eServiceData?.map((location, index) => ({
      value: index + "",
      label: location.headline
    }));
    this.eServiceData?.forEach((data, index) => {
      if (this._cookieCountry && data.preselectForCountries.includes(this._cookieCountry)) {
        this._locationValue = index + "";
        this._setServices(index);
      }
    });
  }
  _selectChanged(evt) {
    this._setServices(evt.detail.newValue);
  }
  _sendTrackingClick(text, url, subtitle = "") {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_interaction",
          event_version: "v2",
          component_name: "header",
          interaction_effect: "navigation",
          interaction_element: subtitle ? `${subtitle}:${text.replace(/\s+/g, "-").toLowerCase()}` : text.replace(/\s+/g, "-").toLowerCase(),
          interaction_result: url,
          interaction_text: `e-services__${this._currentData.headline.replace(/\s+/g, "-").toLowerCase()}__${subtitle ? subtitle + ":" : ""}${text.replace(/\s+/g, "-").toLowerCase()}`,
          interaction_type: "click"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _setServices(index) {
    if (!this.eServiceData) {
      return;
    }
    this._currentData = this.eServiceData[index];
  }
  _trackAllServicesClick(customEvent) {
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.stopPropagation();
    this._sendTrackingClick(
      getEventElement(customEvent, "JB-BUTTON-TERTIARY").textContent ?? "",
      getEventElement(customEvent, "A").getAttribute("href")
    );
  }
  _trackIndividualClick(customEvent) {
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.stopPropagation();
    this._sendTrackingClick(
      getEventElement(customEvent, "JB-BUTTON-TERTIARY").textContent ?? "",
      getEventElement(customEvent, "A").getAttribute("href"),
      "for-individuals"
    );
  }
  _trackIntermediaryClick(customEvent) {
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.stopPropagation();
    this._sendTrackingClick(
      getEventElement(customEvent, "JB-BUTTON-TERTIARY").textContent ?? "",
      getEventElement(customEvent, "A").getAttribute("href"),
      "for-intermediaries"
    );
  }
  render() {
    return ke`
      <div class="eservices">
        <div class="locationselect">
          <h4>${this.headline}</h4>
          ${this._eServiceLocations ? ke`<jb-select
                @jb-select:changed=${this._selectChanged}
                .options=${this._eServiceLocations}
                .value=${this._locationValue}
                .placeholder=${this.pleaseSelect}
                inverted
                type="iseservices"
                .ariaLabels=${this.ariaLabels?.selectLanguage ? { label: this.ariaLabels.selectLanguage } : {}}
              >
              </jb-select>` : D}
        </div>
        ${this._currentData ? ke`
              <div class="links">
                ${this._currentData.forIndividuals.links?.length > 0 ? ke`<div class="individuals">
                      <h5>${this._currentData.forIndividuals.headline}</h5>
                      ${this._currentData.forIndividuals.cta ? ke`<h6>${this._currentData.forIndividuals.cta}</h6>` : D}
                      <ul
                        aria-label="${this._currentData.forIndividuals.headline}: ${this._currentData.forIndividuals.cta}"
                      >
                        ${this._currentData.forIndividuals.links.map(
      (link) => ke`<li>
                              <jb-button-tertiary
                                @jb-link:clicked=${this._trackIndividualClick}
                                inverted
                                .link=${link.link}
                                >${link.text}</jb-button-tertiary
                              >
                            </li>`
    )}
                      </ul>
                    </div>` : D}
                ${this._currentData.forIntermediaries && this._currentData.forIntermediaries.links.length > 0 ? ke`
                      <div class="intermediaries">
                        <h5>${this._currentData.forIntermediaries.headline}</h5>
                        ${this._currentData.forIntermediaries.cta ? ke`<h6>${this._currentData.forIntermediaries.cta}</h6>` : D}
                        <ul
                          aria-label="${this._currentData.forIntermediaries.headline}: ${this._currentData.forIntermediaries.cta}"
                        >
                          ${this._currentData.forIntermediaries.links.map(
      (link) => ke`<li>
                                <jb-button-tertiary
                                  @jb-link:clicked=${this._trackIntermediaryClick}
                                  inverted
                                  .link=${link.link}
                                  >${link.text}</jb-button-tertiary
                                >
                              </li>`
    )}
                        </ul>
                      </div>
                    ` : D}
                ${this._currentData.furtherLinks ? ke`<div
                      class="${Rt({
      furtherlinks: true,
      multiple: this._currentData.furtherLinks.links.length > 1
    })}"
                    >
                      <h5>${this._currentData.furtherLinks?.headline}</h5>
                      ${this._currentData.furtherLinks?.cta ? ke`<h6>${this._currentData.furtherLinks?.cta}</h6>` : D}
                      <ul
                        aria-label="${this._currentData.furtherLinks?.headline}: ${this._currentData.furtherLinks?.cta}"
                      >
                        ${this._currentData.furtherLinks?.links.map(
      (link) => ke`<li>
                              <jb-button-tertiary
                                @jb-link:clicked=${this._trackAllServicesClick}
                                inverted
                                .link=${link.link}
                                >${link.text}</jb-button-tertiary
                              >
                            </li>`
    )}
                      </ul>
                    </div>` : D}
              </div>
              ${this._currentData.furtherLinks && this._currentData.furtherLinks.links.length === 1 ? ke`<jb-button-tertiary
                    class="furtherlink"
                    @jb-link:clicked=${this._trackAllServicesClick}
                    inverted
                    .link=${this._currentData.furtherLinks.links[0].link}
                    >${this._currentData.furtherLinks.links[0].text}</jb-button-tertiary
                  >` : D}
            ` : D}
      </div>
    `;
  }
};
JbEServiceOverlay.styles = [reset_css_default, jb_e_service_overlay_css_default];
JbEServiceOverlay.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Object })
], JbEServiceOverlay.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Array })
], JbEServiceOverlay.prototype, "eServiceData", 2);
__decorateClass([
  n()
], JbEServiceOverlay.prototype, "headline", 2);
__decorateClass([
  n()
], JbEServiceOverlay.prototype, "pleaseSelect", 2);
__decorateClass([
  r2()
], JbEServiceOverlay.prototype, "_currentData", 2);
__decorateClass([
  r2()
], JbEServiceOverlay.prototype, "_eServiceLocations", 2);
JbEServiceOverlay = __decorateClass([
  customElement("jb-e-service-overlay")
], JbEServiceOverlay);

export {
  JbEServiceOverlay
};
